import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import messages from '../messages';
import style from './carriers-additional.module.less';

export const EmptyCarrierTableBody = () => (
  <FlexRow className={style['empty-carrier-table-body']}>
    <Text textType={TextType.Paragraph} value={messages.emptyAdditionalCarrierTableMessage} />
  </FlexRow>
);
